const PHONE_PAUSE_TYPES = new Set(['BREAK', 'ACW', 'OUTGOING_ONLY']);
export function normalizeClearedPauseTypes(raw) {
    if (!Array.isArray(raw))
        return [];
    return raw.filter((value) => typeof value === 'string' && PHONE_PAUSE_TYPES.has(value));
}
/** Legacy break-only events omit `clearedPauseTypes` — treat as break end only. */
export function resolveForceServiceClearedTypes(event) {
    const explicit = normalizeClearedPauseTypes(event.clearedPauseTypes);
    return explicit.length > 0 ? explicit : ['BREAK'];
}
export function describeClearedPauseTypes(types) {
    const labels = {
        BREAK: 'break',
        ACW: 'after-call work',
        OUTGOING_ONLY: 'incoming call pause',
    };
    return types.map((type) => labels[type]).join(', ');
}
export function buildBreakUserTopic(username) {
    const trimmed = username.trim();
    if (!trimmed) {
        throw new Error('Break topic requires a username.');
    }
    return `/topic/break.user.${trimmed}`;
}
export function parseBreakEvent(raw) {
    try {
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object')
            return null;
        const event = parsed;
        if (typeof event.eventType !== 'string')
            return null;
        return {
            eventType: event.eventType,
            breakRecord: event.breakRecord && typeof event.breakRecord === 'object'
                ? event.breakRecord
                : undefined,
            endedBy: typeof event.endedBy === 'string' ? event.endedBy : undefined,
            clearedPauseTypes: normalizeClearedPauseTypes(event.clearedPauseTypes),
        };
    }
    catch {
        return null;
    }
}
